export class LocationSearchDTO {
  constructor(public readonly search: string) {
  }
}
